import React, { useContext, useEffect, useState } from 'react';
import { ClaimContext } from '../../../contexts/ClaimContext';
import { InventoriesContext } from '../../../contexts/InventoriesContext';
import BillsByDateAndStatus from './BillsByDateAndStatus/BillsByDateAndStatus';
import ImproperRetention from './ImproperRetention';
import PaymentMethodsAndBankAccounts from './MeansPaymentAndBankAccounts/PaymentMethodsAndBankAccounts';
import MissingBills from './MissingBills';
import NewClaimSelection from './NewClaimSelection';
import OtherClaim from './OtherClaim';
import PurchaseOrdersClaimSelection from './PurchaseOrdersClaim/PurchaseOrdersClaimSelection';
import ServicePagesClaimSelection from './ServicePages/ServicePagesClaimSelection';

export const transitionTimeout = 400;

const CLAIMS = [
  { id: 1, component: <MissingBills /> },
  { id: 2, component: <BillsByDateAndStatus /> },
  { id: 3, component: <PaymentMethodsAndBankAccounts /> },
  { id: 4, component: <ImproperRetention /> },
  { id: 5, component: <PurchaseOrdersClaimSelection /> },
  { id: 6, component: <ServicePagesClaimSelection /> },
  { id: 7, component: <OtherClaim /> },
];

const ClaimWizard = () => {
  const { currentStep, selectedClaimId } = useContext(ClaimContext);
  const { getTheClaimTypes } = useContext(InventoriesContext);

  const [claimsAvailables, setClaimsAvailables] = useState([]);

  useEffect(() => {
    getTheClaimTypes().then(res => {
      setClaimsAvailables(CLAIMS.map(c => ({ ...c, text: res.find(r => r.id === c.id).name })));
    });
  }, []);

  return !currentStep || currentStep === 0 || !selectedClaimId ? (
    <NewClaimSelection claimsAvailables={claimsAvailables} />
  ) : (
    claimsAvailables.filter(c => c.id === selectedClaimId)[0].component
  );
};

export default ClaimWizard;
